/**
 * Created by Administrator on 2017/10/27.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
declare var alertify: any;
declare var $: any;
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
@Component({
  templateUrl: "./editProduct.html",
})
export class EditProduct implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private fileupload: FileUpload,
    private location: Location,
    private domSanitizer: DomSanitizer
  ) {}

  private data: any = {
    id: "",
    image: "",
    name: "",
    genreName: "",
    desc: "",
    point: "",
    price: "",
    descImage: "",
    updatedBy: "",
    updatedTime: "",
    productElement: "",
    detailImages: "",
    media1: "",
    media2: "",
    openShare: false,
    shareImage: "",
    shareNotice: "",
    shareUrl: "",
    active: 1,
    startTime: "",
    endTime: "",
    recommendedDesc:""
  };

  private detailImages = [];

  //'山桑子萃取物','毕荣建','维生素'
  private productElements = [];

  private desc: string = "<p></p>";
  private recommendedDesc: string = "<p></p>";

  private productElementName: string = "";
  private isProgress = true;
  private videoUrl: any;
  private videoUrl2: any;
  private id: number = 0;
  private imagePath: string = "";
  private isCreate: boolean = false;
  private isLocalhost: any = {
    media1: false,
    media2: false,
  };
  private mediaTemp: any = {
    media1: "",
    media2: "",
  };
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
    });

    if (this.id != 0) {
      this.getPath();
      this.getData();
    } else {
      this.isCreate = true;
    }
    let self = this;
    $("#startTime")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
      })
      .on("changeDate", function (ev) {
        $("#endTime").datetimepicker("setStartDate", $("#startTime").val());
        self.data.startTime = $(this).val();
      });
    $("#endTime")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
        // startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
      })
      .on("changeDate", function (ev) {
        $("#startTime").datetimepicker("setEndDate", $("#endTime").val());
        self.data.endTime = $(this).val();
      });
  }

  private getData(): void {
    this.detailImages = [];
    this.HttpService.getData(API.product + "/" + this.id).then((res) => {
      this.data = res.data;
      this.videoUrl = this.getVideoUrl(this.data.media1, "media1");
      this.videoUrl2 = this.getVideoUrl(this.data.media2, "media2");
      this.mediaTemp.media1 = this.data.media1;
      this.mediaTemp.media2 = this.data.media2;
      if (this.data.productElement != "") {
        this.productElements = this.data.productElement.split("|");
      }
      if (this.data.detailImages != "") {
        let dImages = this.data.detailImages.split("|");
        for (let i = 0; i < dImages.length; i++) {
          this.detailImages.push({
            name: dImages[i],
            imagePath: this.imagePath,
          });
        }
      }
      this.desc = this.data.desc;
      this.recommendedDesc = this.data.recommendedDesc;
      this.detailImages.push({ name: "", imagePath: "" });
      console.log(this.detailImages)
      this.isProgress = false;
    });
  }

  private addProductElement(name: string): void {
    this.productElements.push(name);
    this.productElementName = "";
  }

  private removeProductElement(index: number): void {
    this.productElements.splice(index, 1);
  }

  private removeDetailImage(index: number, event): void {
    event.stopPropagation();
    if (this.detailImages.length > 1) {
      if (this.detailImages[index].name != "") {
        this.detailImages.splice(index, 1);
      }
    }
  }

  private uploadDetailImage(index: number): void {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        if (self.detailImages[index].name == "") {
          self.detailImages.push({ name: "", imagePath: "" });
        }
        self.detailImages[index].name = temRes.data.fileName;
        self.detailImages[index].imagePath = self.tempPath;
      }
    });
  }

  // 获取路径
  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
    });
  }

  private onReady(): void {
    this.desc = this.data.desc;
    this.recommendedDesc = this.data.recommendedDesc;
  }

  private onChange(): void {
    this.data.desc = this.desc;
    this.data.recommendedDesc = this.recommendedDesc;
  }

  private submit(): void {
    if (this.productElements.length > 0) {
      this.data.productElement = this.productElements.join("|");
    }
    let temImages = [];
    if (this.detailImages.length > 0) {
      for (let i = 0; i < this.detailImages.length; i++) {
        if (this.detailImages[i].name != "") {
          temImages.push(this.detailImages[i].name);
        }
      }
      this.data.detailImages = temImages.join("|");
    }

    this.HttpService.postData(API.product, {
      id: this.id,
      image: this.data.image,
      desc: this.data.desc,
      descImage: this.data.descImage,
      productElement: this.data.productElement,
      detailImages: this.data.detailImages,
      media1: this.data.media1,
      media2: this.data.media2,
      active: this.data.active,
      startTime: this.data.startTime,
      endTime: this.data.endTime,
      recommendedDesc:this.data.recommendedDesc
    }).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  private showIconEn: boolean = false;
  private showDescImage: boolean = false;
  private showShareImage: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "image":
            self.showIconEn = true;
            break;
          case "descImage":
            self.showDescImage = true;
            break;
          case "shareImage":
            self.showShareImage = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      }
    });
  }

  private getVideoUrl(mediaUrl, type): any {
    this.isLocalhost[type] = false;
    if (
      mediaUrl.indexOf("www.youtube.com/embed") == -1 &&
      mediaUrl.indexOf("youtu") != -1
    ) {
      let url;
      if (mediaUrl.indexOf("www.youtube.com/watch") != -1) {
        url = mediaUrl.replace("watch?v=", "embed/");
        if (mediaUrl.indexOf("&") != -1) {
          url = url.substring(0, mediaUrl.indexOf("&") - 2);
        }
      } else if (mediaUrl.indexOf("youtu.be") != -1) {
        url = mediaUrl.replace("youtu.be", "www.youtube.com/embed");
      }
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    } else if (
      mediaUrl.indexOf(location.hostname) != -1 ||
      mediaUrl.indexOf("localhost") != -1 ||
      mediaUrl.indexOf("api.naturally-plus.com.tw") != -1 ||
      mediaUrl.indexOf("s3-ap-northeast-1.amazonaws.com") != -1
    ) {
      this.isLocalhost[type] = true;
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    } else if (mediaUrl.indexOf("www.youtube.com/embed") != -1) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    } else {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    }
  }

  ngDoCheck() {
    if (this.mediaTemp.media1 != this.data.media1) {
      this.mediaTemp.media1 = this.data.media1;
      this.videoUrl = this.getVideoUrl(this.data.media1, "media1");
    }
    if (this.mediaTemp.media2 != this.data.media2) {
      this.mediaTemp.media2 = this.data.media2;
      this.videoUrl2 = this.getVideoUrl(this.data.media2, "media2");
    }
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/product/EditProduct.componment.ts